import { buildingStore } from "store/Building/BuildingStore";
import useFeatureFlag from "./useFeatureFlag";
import { sidebarMenuStore } from "features/SidebarMenu/SidebarMenuStore";
import { LicenseFeatureEnum } from "api-client";

export const licenseFeatureFlagMap = {
  [LicenseFeatureEnum.AnalyticsDashboards]: "",
  [LicenseFeatureEnum.BuildingDataUploadIfcCsv]: "",
  [LicenseFeatureEnum.MaterialSalesFlow]: "",
  [LicenseFeatureEnum.VariantComparison]: "",
  [LicenseFeatureEnum.MainDashboardRetool]: "",
  [LicenseFeatureEnum.Mapping]: "",
  [LicenseFeatureEnum.Inventory]: "",
  [LicenseFeatureEnum.Integrations]: "integrations_menu",
  [LicenseFeatureEnum.PotfolioScreener]: "",
  [LicenseFeatureEnum.ButtonLcaGrpExportsEnabled]: "",
  [LicenseFeatureEnum.ExportDgnbGebauderessourcenpass]: "",
  [LicenseFeatureEnum.ExportEnvironmentalReport]: "",
  [LicenseFeatureEnum.InventoryExports]: "",
  [LicenseFeatureEnum.PdfReportExports]: "",
  [LicenseFeatureEnum.Audits]: "",
  [LicenseFeatureEnum.ProductPublishing]: "",
  [LicenseFeatureEnum.ArchiveBuilding]: "",
  [LicenseFeatureEnum.B6Calculator]: "",
};

export function useFeatureAccess() {
  const { currentBuilding } = buildingStore;
  const { currentOrganisation: defaultOrganisation } = sidebarMenuStore;
  const { isFeatureVisible } = useFeatureFlag();

  const hasFeature = (key: string) => {
    const isLicenseKey = key in licenseFeatureFlagMap;
    const featureFlagKey =
      licenseFeatureFlagMap[key as keyof typeof licenseFeatureFlagMap];

    const isAvailable =
      currentBuilding?.available_features?.includes(key) ||
      defaultOrganisation?.available_features?.includes(key);

    if (!isLicenseKey) {
      // It's a pure feature flag
      return isFeatureVisible(key);
    }

    if (featureFlagKey) {
      // It's a license key that also uses a feature flag
      return isFeatureVisible(featureFlagKey) && !!isAvailable;
    }

    // License key without a mapped feature flag
    return !!isAvailable;
  };

  return {
    hasFeature,
  };
}
